<template>
	<section id="footer"></section>
</template>

<script>

export default {
  data () {
    return {
     
    }
  },
  computed: {
   
  },
  methods: {
  	
  }
}
</script>

<style lang="scss" scoped>

	#footer {
		width: 100%;
		height: 20px;
    margin-top: 30px;
	}

</style>
